import { PrimarySecondaryPage } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { DocumentUploadSupportingContent, UploadBankStatements } from "../../components";

export const UploadBankStatementsPage = () => {
  const intl = useIntl();

  return (
    <PrimarySecondaryPage
      title={intl.formatMessage({
        id: "funding_application: uplaod bank statements page header",
        defaultMessage: "Upload bank statements",
      })}
      primaryContent={<UploadBankStatements />}
      secondaryContent={<DocumentUploadSupportingContent />}
    />
  );
};
